import React from 'react'

function Folder ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 21.273'>
      <path d='M21.818,21.441H2.182A2.188,2.188,0,0,1,0,19.259V2.35A2.188,2.188,0,0,1,2.182.168H6.641A1.648,1.648,0,0,1,7.8.645L9.886,2.738a.541.541,0,0,0,.389.157H21.818A2.188,2.188,0,0,1,24,5.077V19.259A2.188,2.188,0,0,1,21.818,21.441ZM2.182,1.259A1.094,1.094,0,0,0,1.091,2.35V19.259A1.094,1.094,0,0,0,2.182,20.35H21.818a1.094,1.094,0,0,0,1.091-1.091V5.077a1.094,1.094,0,0,0-1.091-1.091H10.268a1.647,1.647,0,0,1-1.159-.477L7.023,1.416a.54.54,0,0,0-.389-.157Zm0,0' transform='translate(0 -0.168)' />
    </svg>
  )
}

Folder.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Folder
